/*
    Модель для текстового представления курсора
    TODO: может быть в нее стоит вынести методы формирования текстового представления,
    но пока это не нужно - методы формирования сейчас в самих курсорах
*/
export class CursorLabelModel {
  /*
        Форматтер для значений по оси x
    */
  xValueFormatter: Function | null = null;

  /*
        Единицы измерения по оси X
    */
  xUnits: string;

  constructor(xUnits: string, xValueFormatter: Function | null = null) {
    this.xUnits = xUnits;
    this.xValueFormatter = xValueFormatter;
  }
}
